import { useState, type ReactNode } from 'react';
import {
  usePricingServiceCustomerContainerPriceOptions,
  EditBlock,
} from '@hungryroot/plan';
import { type ServingSize } from '@hungryroot/rest';
import { EditContainerQuantityModal } from '../EditContainerQuantityModal/EditContainerQuantityModal';

type EditContainerQuantityBlockProps = {
  className?: string;
  customerId: number;
  containerId: number;
  initialValue: number;
  servingSize: ServingSize;
  icon: ReactNode;
  heading: string;
  description: string;
  minQuantity: number;
  inputLabel: string;
  modalHeading: string;
  modalBody: string;
  onSubmit: (quantity: number, servingSize?: ServingSize) => void;
  onServingSizeChange?: (value: ServingSize) => void;
  onCancel?: () => void;
  confirmButtonText: string;
  editDisabled?: boolean;
  containerName: string;
  pricingVersion?: number;
};

export const EditContainerQuantityBlock = ({
  className,
  customerId,
  containerId,
  icon,
  heading,
  description,
  initialValue,
  servingSize,
  minQuantity,
  inputLabel,
  modalHeading,
  modalBody,
  onSubmit,
  onServingSizeChange,
  onCancel,
  confirmButtonText,
  editDisabled,
  containerName,
  pricingVersion,
}: EditContainerQuantityBlockProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: priceOptions, isLoading: isPriceOptionsLoading } =
    usePricingServiceCustomerContainerPriceOptions({
      customerId,
      containerId,
    });

  if (isPriceOptionsLoading || !priceOptions) {
    return null;
  }

  return (
    <>
      <EditBlock
        className={className}
        heading={heading}
        description={description}
        icon={icon}
        onClick={() => setIsModalOpen(true)}
        editDisabled={editDisabled}
      />
      {isModalOpen && pricingVersion && (
        <EditContainerQuantityModal
          pricingVersion={pricingVersion}
          containerName={containerName}
          containerId={containerId}
          isOpen={isModalOpen}
          onCancel={() => {
            onCancel?.();
            setIsModalOpen(false);
          }}
          onSubmit={(value: number, nextServingSize: ServingSize) => {
            onSubmit(value, nextServingSize);
            setIsModalOpen(false);
          }}
          initialValue={initialValue}
          minQuantity={minQuantity}
          confirmButtonText={confirmButtonText}
          inputLabel={inputLabel}
          modalHeading={modalHeading}
          modalBody={modalBody}
          servingSize={servingSize}
          onServingSizeChange={onServingSizeChange}
          priceOptions={priceOptions}
        />
      )}
    </>
  );
};
